import { Form } from "semantic-ui-react";
import { PermitFieldValueInput } from "../../models/globalTypes";
import { TextTemplateField } from "../../models/TemplateField";

interface Props {
  field: TextTemplateField;
  value: PermitFieldValueInput | undefined;
  onChange: (fieldKey: string, update: Partial<PermitFieldValueInput>) => void;
  disabled: boolean;
  error: string | undefined;
  required?: boolean;
}

const TextFieldInput = ({ field, value, onChange, disabled, error, required }: Props) => {
  const currentValue = value?.stringValue ?? "";

  if (field.isMultiLine) {
    return (
      <Form.Field required={required}>
        <label>{field.label}</label>
        <Form.TextArea
          value={currentValue}
          maxLength={field.maxLength ?? undefined}
          rows={3}
          disabled={disabled}
          error={error}
          onChange={(_, { value: v }) => onChange(field.key, { stringValue: v as string })}
        />
      </Form.Field>
    );
  }

  return (
    <Form.Field required={required}>
      <label>{field.label}</label>
      <Form.Input
        value={currentValue}
        maxLength={field.maxLength ?? undefined}
        disabled={disabled}
        error={error}
        onChange={(_, { value: v }) => onChange(field.key, { stringValue: v as string })}
      />
    </Form.Field>
  );
};

export default TextFieldInput;
